"use client";
import React, { useState } from "react";
import { useRouter } from "next/navigation";

export default function EMICalculatorPage() {
  const [amount, setAmount] = useState(100000);
  const [tenure, setTenure] = useState(12);
  const [rate, setRate] = useState(8.5);
  const [rateType, setRateType] = useState("fixed");
  const [mobile, setMobile] = useState("");
  const router = useRouter();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // You can pass the values to the result page via query params or state
    router.push(`/loan/calculator/result?amount=${amount}&tenure=${tenure}&rate=${rate}&rateType=${rateType}&mobile=${mobile}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center py-10">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold text-blue-700 mb-2 text-center">Loan EMI Calculator</h1>
        <p className="text-gray-600 text-center mb-6">
          Calculate your monthly EMI for personal, home, or car loans. Enter your loan details below and get instant results.
        </p>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Loan Amount (AED)</label>
            <input
              type="number"
              min={1000}
              step={100}
              value={amount}
              onChange={e => setAmount(Number(e.target.value))}
              className="w-full border rounded px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tenure (Months)</label>
            <input
              type="number"
              min={1}
              max={360}
              value={tenure}
              onChange={e => setTenure(Number(e.target.value))}
              className="w-full border rounded px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Interest Rate (%)</label>
            <input
              type="number"
              min={0.1}
              step={0.01}
              value={rate}
              onChange={e => setRate(Number(e.target.value))}
              className="w-full border rounded px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>
          <div className="flex items-center gap-6 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="rateType"
                value="fixed"
                checked={rateType === "fixed"}
                onChange={() => setRateType("fixed")}
                className="accent-blue-600"
              />
              Fixed Rate
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="rateType"
                value="reducing"
                checked={rateType === "reducing"}
                onChange={() => setRateType("reducing")}
                className="accent-blue-600"
              />
              Reducing Rate
            </label>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile No. (optional)</label>
            <input
              type="tel"
              placeholder="Mobile No."
              value={mobile}
              onChange={e => setMobile(e.target.value)}
              className="w-full border rounded px-3 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold text-lg hover:bg-blue-700 transition"
          >
            Calculate EMI
          </button>
        </form>
      </div>
    </div>
  );
}
